import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Home from '@/views/Home.vue'
import Login from '@/components/Login.vue'

import ElementUI from 'element-ui'

//用户授权获取id
const Notice = () => import('@/components/Notice.vue')

const When = () => import('@/views/When.vue')
const Redeem = () => import('@/views/Redeem.vue')
const Beo = () => import('@/views/Beo.vue')
const Absolutely = () => import('@/views/Absolutely.vue')
const Assessment = () => import('@/views/Assessment.vue')
const Already = () => import('@/views/Already.vue')
const Charged = () => import('@/views/Charged.vue')
const Modify = () => import('@/views/Modify.vue')
const Scrolling = () => import('@/views/Scrolling.vue')
const Establish = () => import('@/views/Establish.vue')
// const Redeems = () => import('@/views/Redeems.vue')
const Kan = () => import('@/views/Kan.vue')
const Review = () => import('@/views/Review.vue')
const Ces = () => import('@/views/Ces.vue')
const Finance = () => import('@/views/Finance.vue')
const Whens = () => import('@/views/Whens.vue')
const Redeemed = () => import('@/views/Redeemed.vue')
const Offline = () => import('@/views/Offline.vue')
const Recycle = () => import('@/views/Recycle.vue')
const Ware = () => import('@/views/Ware.vue')
const Wares = () => import('@/views/Wares.vue')
const Statistics = () => import('@/views/Statistics.vue')
const Revs = () => import('@/components/Revs.vue')
const Take = () => import('@/components/Take.vue')
const Appraisal = () => import('@/components/Appraisal.vue')
const Query = () => import('@/components/Query.vue')

//汽车组件引入
const Cars = () => import('@/views/Cars.vue')
const Cards = () => import('@/components/cars/Cards.vue')
const Reviews = () => import('@/views/Reviews.vue')
const Scars = () => import('@/views/Scars.vue')
const Ransom = () =>import('@/views/Ransom.vue')
// const Contract = () => import('@/components/Contract.vue')
const CarDetail = () => import('@/components/cars/CarDetail.vue')
const CarForbidden = () => import('@/components/cars/CarForbidden.vue')

//业务流水组件
const Flow = ()=>import('@/components/Flow.vue')

//打印票据组件
const Printing = ()=>import('@/components/Printing.vue')


//未更新信息的客户
const Test =  ()=>import('@/components/Test.vue')

//修改账号密码
const System = ()=>import('@/components/System.vue')

//优惠券
const Coupons = ()=>import('@/components/Coupons.vue')
const Create = ()=>import('@/components/coupon/Create.vue')
const Detail = ()=>import('@/components/coupon/Detail.vue')

//积分
const Integrals = ()=>import('@/components/integral/Integrals.vue')

//每日金价
const RealTimesGold = ()=>import('@/components/realTimesGold/RealTimesGold.vue')
const Goldprice = ()=>import('@/components/realTimesGold/Goldprice.vue')
const EchartsTime =()=>import('@/components/realTimesGold/EchartsTime.vue')

//房产业务

const CreateHouse = ()=>import('@/components/house/createhouse.vue')  //房产建当
const ReviewHouse = ()=>import('@/components/house/reviewhouse.vue')  // 房产复核
const WhenHouse = ()=>import('@/components/house/whenhouse.vue')      // 在当房产
const RedeemHouse = ()=>import('@/components/house/redeemhouse.vue')  //赎回房产业务
const PawnHouse = () =>import('@/components/house/pawnhouse.vue')     //绝当房产业务
const HouseDetail =()=>import('@/components/house/HouseDetails.vue')  //房产详情

// 设置费率
const InteresRate =()=>import('@/components/interesRate/InteresRate.vue')

//设置微信通知
const WechatMsg =()=>import('@/components/wechatMsg/WechatMsg.vue')

//当品登记
const DpRegister =()=>import('@/components/register/DpRegister.vue') 

//商城管理
const Shops =()=>import('@/components/shop/Shops.vue')




const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/home',
            name: 'home',
            title: '首页',
            component: Home,
            redirect: {
                name: 'when'
            },
            meta: {
                login: true
            },
            children: [{
                path: '/when',
                name: 'when',
                title: '在当订单',
                component: When,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                    
                        next();
                   
                    return;
                }
            },
            {
                path: '/redeem',
                name: 'redeem',
                title: '赎回订单',
                component: Redeem,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                    
                        next();
                   
                    return;
                }
            }, {
                path: '/beo',
                name: 'beo',
                title: '逾期订单',
                component: Beo,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                  
                        next();
                
                    return;
                }
            }, {
                path: '/absolutely',
                name: 'absolutely',
                title: '绝当订单',
                component: Absolutely,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                
                        next();
                   
                    return;
                }
            }, {
                path: '/assessment',
                name: 'assessment',
                title: '在线评估',
                component: Assessment,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                  
                        next();
                    
                    return;
                }
            }, {
                path: '/already',
                name: 'already',
                title: '已评估订单',
                component: Already,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                 
                        next();
                    
                    return;
                }
            }, {
                path: '/charged',
                name: 'charged',
                title: '当户资料管理',
                component: Charged,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
               
                        next();
                  
                    return;
                }

            }, {
                path:'/kan',
                name:'kan',
                title:'业务综合查询',
                component: Kan,
                meta:{
                    login:true
                }
            },{
                path: '/modify',
                name: 'modify',
                title: '修改今日金价',
                component: Modify,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                
                        next();
                   
                    return;
                }
            }, {
                path: '/scrolling',
                name: 'scrolling',
                title: '修改滚动文字',
                component: Scrolling,
                meta: {
                    login: true
                },  beforeEnter: (to, from, next) => {
                
                        next();
                    
                    return;
                }
            }, {
                path: '/establish',
                name: 'establish',
                title: '建当',
                component: Establish,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                  
                        next();
                   
                    return;
                }
            }, {
                path: '/review',
                name: 'review',
                title: '复核',
                component: Review,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                    const token = sessionStorage.getItem('token');
                    if (token !== 'caddGl002' && token !== 'caddGl003' &&  token !== 'caddGl012' && token !== 'caddGl014'  && token !== 'caddGl004' && token !== 'caddGl006' && token !== 'caddGl005' && token !== 'caddGl007' && token !== 'caddGl019' ) {
                        // alert('对不起，该账号没有权限操作该功能')
                        ElementUI.MessageBox.alert('对不起，您没有该功能权限,如需开通请联系管理员').then(() => {
                            router.push('/whens')
                                setTimeout(() => {
                                    router.go(0)
                                }, 600)
                        
                           
                        }).catch(() => {
                            router.push('/whens')
                                setTimeout(() => {
                                    router.go(0)
                                }, 600)
                     
                        })
                        return
                    } else {
                        next();
                    }
                    return;
                }

            },
            {
                path: '/details',
                name: 'details',
                title: '订单详情',
                component: Ces,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                  
                        next();
                  
                    return;
                }
            },
            {
                path: '/revs',
                name: 'revs',
                title: '复核操作',
                component: Revs,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                    const token = sessionStorage.getItem('token');
                    if (token !== 'caddGl002' && token !== 'caddGl003' &&  token !== 'caddGl012' && token !== 'caddGl014'  && token !== 'caddGl004' && token !== 'caddGl006' && token !== 'caddGl005' && token !== 'caddGl007' && token !== 'caddGl019') {
                        // alert('对不起，该账号没有权限操作该功能')
                        ElementUI.MessageBox.alert('对不起，您没有该功能权限,如需开通请联系管理员').then(() => {
                                router.push('/whens')
                                setTimeout(() => {
                                    router.go(0)
                                }, 600)
                        }).catch(() => {
                            router.push('/whens')
                            setTimeout(() => {
                                        router.go(0)
                                    }, 600)
                        })
                        return
                    } else {
                        next();
                    }
                    return;
                }
            }, {
                path: '/take',
                name: 'take',
                title: '断当收回',
                component: Take,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                  
                        next();
                
                    return;
                }
            }, {
                path: '/appraisal',
                name: 'appraisal',
                title: '鉴定评估',
                component: Appraisal,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                   
                        next();
                    
                    return;
                }
            },

            {
                path: '/finance',
                name: 'finance',
                title: '当台出纳',
                component: Finance,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                   
                        next();
                   
                    return;
                }
            },
            {
                path: '/whens',
                name: 'whens',
                title: '线下在当订单',
                component: Whens,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                   
                        next();
                  
                    return;
                }
            }, {
                path: '/redeemed',
                name: 'redeemed',
                title: '线下赎回订单',
                component: Redeemed,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                   
                        next();
                    
                    return;
                }
            }, {
                path: '/offline',
                name: 'offline',
                title: '线下绝当订单',
                component: Offline,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                   
                        next();
                    
                    return;
                }
            },
            {
                path: '/recycle',
                name: 'recycle',
                title: '回收订单',
                component: Recycle,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                   
                        next();
                    
                    return;
                }
            },
            //汽车典当业务
            {
                path: '/Car/cars',
                name: 'cars',
                title: '汽车建当',
                component: Cars,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                   
                        next();
                    
                    return;
                }
            },
            {
                path: '/Car/reviews',
                name: 'reviews',
                title: '汽车复核',
                component: Reviews,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                        next();
                    return;
                }
            },{
                path:'/Car/car_details',
                name:'cards',
                title:'汽车复核详情',
                component: Cards,
                meta:{
                    login:true
                },
                beforeEnter: (to, from, next) => {
                    
                        next();
                 
                    return;
                }
            },
            {
                path:'/Car/CarDetail',
                name:'CarDetail',
                title:'汽车详情',
                component: CarDetail,
                meta:{
                    login:true
                },
                beforeEnter: (to, from, next) => {
                    
                        next();
                 
                    return;
                }
            },
            {
                path: '/Car/scars',
                name: 'scars',
                title: '在当汽车',
                component: Scars,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                   
                        next();
                   
                    return;
                }
            },
            // {
            //     path:'/contract',
            //     name:'contract',
            //     title:'汽车合同详情',
            //     component:Contract,
            //     meta:{
            //         login:true
            //     }
            // },
            {
                path: '/Car/ransom',
                name: 'ransom',
                title: '汽车赎回业务',
                component: Ransom,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                   
                        next();
                   
                    return;
                }
            },
            {
                path: '/Car/CarForbidden',
                name: 'CarForbidden',
                title: '汽车绝当业务',
                component: CarForbidden,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                   
                        next();
                   
                    return;
                }
            },
            // {
            //     path:'Car/'
            // },
            {
                path: '/ware',
                name: 'ware',
                title: '确认入库',
                component: Ware,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                    
                        next();
                    
                    return;
                }
            },
            {
                path: '/wares',
                name: 'wares',
                title: '物品出库',
                component: Wares,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                    
                        next();
                    
                    return;
                }
            },
            {
                path: '/statistics',
                name: 'statistics',
                title: '仓库统计',
                component: Statistics,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                    
                        next();
                    
                    return;
                }
            },{
                path:'/query',
                name:'query',
                title:'业务查询',
                component: Query,
                meta:{
                    login:true
                },
                beforeEach:(next) =>{
                   
                        next();
                    
                    return;
                }
            }
            ,{
                path: '/flow',
                name: 'flow',
                title: '业务流水查询',
                component: Flow,
                meta: {
                    login: true
                },
    
            },
            {
                path: '/printing',
                name: 'printing',
                title: '打印票据',
                component: Printing,
                meta: {
                    login: true
                },
    
            },{
                path: '/system',
                name: 'system',
                title: '系统设置',
                component: System,
                meta: {
                    login: true
                },
            },
            {
                path: '/wechatMsg',
                name: 'WechatMsg',
                title: '微信通知',
                component: WechatMsg,
                meta: {
                    login: true
                },
                beforeEnter: (to, from, next) => {
                    const token = sessionStorage.getItem('token');
                    if (token !== 'caddGl002') {
                        // alert('对不起，该账号没有权限操作该功能')
                        ElementUI.MessageBox.alert('对不起，您没有该功能权限,如需开通请联系管理员').then(() => {
                               
                        })
                        return
                    } else {
                        next();
                    }
                    return;
                }
            },
            {
                path: '/test',
                name: 'test',
                title: '未更新个人信息客户',
                component: Test,
             meta:{
                 login:true
             }
            },
            {
                path: '/coupons',
                name: 'coupons',
                title: '优惠券管理',
                component: Coupons,
             meta:{
                 login:true
             },
             children:[{
                 path:'create',
                 name:'create',
                 component: Create
             },{
                 path:'detail',
                 name:'detail',
                 component:Detail
             }]
            },
            {
                path:'/integrals',
                name:'integrals',
                title:'积分',
                component:Integrals,
                meta:{
                    login:true
                }
            },
            {
                path:'/realTimesGold',
                name:'realTimesGold',
                title:'实时金价',
                component:RealTimesGold,
                meta:{
                    login:true
                }
            }, {
                path:'/createHouse',
                name:'createHouse',
                title:'房产建当',
                component:CreateHouse,
                meta:{
                    login:true
                }
            },
            {
                path: '/Register',
                name: 'DpRegister',
                title: '当品登记',
                component: DpRegister,
                meta:{
                    login:true
                }
            },
            {
                path:'/reviewHouse',
                name:'reviewHouse',
                title:'房产复核',
                component:ReviewHouse,
                meta:{
                    login:true
                }
            },
            {
                path:'/whenHouse',
                name:'whenHouse',
                title:'在当房产',
                component:WhenHouse,
                meta:{
                    login:true
                }
            },
            {
                path:'/redeemHouse',
                name:'redeemHouse',
                title:'赎当房产业务',
                component:RedeemHouse,
                meta:{
                    login:true
                }
            },{
                path:'/pawnHouse',
                name:'pawnHouse',
                title:'绝当房产业务',
                component:PawnHouse,
                meta:{
                    login:true
                }
            },
            {
                path:'/House/houseDetail',
                name:'houseDetail',
                title:'房产详情',
                component:HouseDetail,
                meta:{
                    login:true
                }
            },
            {
            path: '/interesRate',
            name: 'InteresRate',
            title: '设置费率',
            component: InteresRate,
            },

            {
                path: '/shop',
                name: 'Shops',
                title: '商城管理',
                component: Shops,
            },
          
        ]
        },
        {
            path: '/login',
            name: 'login',
            title: '登录',
            component: Login,
            meta: {
                login: true
            },

        }
        ,{
            path: '/notice',
            name: 'notice',
            title: '获取用户信息',
            component: Notice,
            // meta: {
            //     login: false
            // },
        },{
            path: '/goldprice',
            name: 'Goldprice',
            title: '今日金价',
            component: Goldprice,
        },
        {
            path: '/echartsTime',
            name: 'EchartsTime',
            title: '今日金价',
            component: EchartsTime,
        },
       
        
        
       
       
       
        {
            path: '*',
            name: 'noFound',
            title: '未找到',
            redirect: {
                name: 'home'
            }
        },
    ]

});




router.beforeEach(async (to, from, next) => {
    const token = sessionStorage.getItem('token');
    const isLogin = !!token
    // console.log(isLogin,token)

    //后续将使用vuex状态管理存储，登入

    if (to.matched.some(item => item.meta.login)) {
        if (isLogin) {

            if(token ==null){
                next({ name: 'login' });
                sessionStorage.removeItem('token');
                return
            }

            if (to.name === 'login') {
                next({ name: 'home' })
            } else {
                next();
            }

            return;
        }
        //没登录，进入login ，直接进入
        if (!isLogin && to.name === 'login') {
            next()

        }
        //没登录，进入的不是login页面，挑到login
        if (!isLogin && to.name !== 'login') {
            next({ name: 'login' })
        }

    } else {
        next();
    }
})




export default router
